@if (berthVisit) {
  @if (context.visit.terminalPlanningEnabled) {
    <div class="row fieldset" [ngClass]="{'disabled': !terminalPlanningActive || berthVisit.ata || berthVisit.atd}">
      <div class="col-md">
        <app-form-group>
          <label>Terminal</label>
          <app-search [(ngModel)]="berthVisit.terminal" [searchFunction]="searchTerminal"
            (ngModelChange)="onTerminalChange($event)"
            required placeholder="Find terminal" [inputFormatter]="terminalFormatter"
            [disabled]="!!terminalVisit?.status">
          </app-search>
        </app-form-group>
        @if (berthVisit.terminalPlanningEnabled) {
          <app-form-group label="Stevedore">
            <app-select [ngModel]="codeToStevedore(berthVisit.stevedore?.shortName)"
              [options]="stevedores"
              [formatter]="utils.stevedoreFormatter"
              disabled required placeholder="Select stevedore">
            </app-select>
          </app-form-group>
        }
        @if (callId) {
          <app-form-group class="fieldset disabled" label="Call id">
            <input [ngModel]="callId" disabled id="{{berthVisit.id}}-callId" appDecimalNumber [maxDecimals]="0"
              class="form-control">
          </app-form-group>
        }
        @if (berthVisit.stevedore?.quaysForPlanning?.length > 1 && !berthVisit.stevedore?.multiQuay) {
          <app-form-group label="Quay">
            <app-select required [ngModel]="quay" (ngModelChange)="berthVisit.quay = $event"
              [options]="berthVisit.stevedore.quaysForPlanning"
              disabled>
            </app-select>
          </app-form-group>
        }
        @if (showUseTerminalBollards()) {
          <app-form-group
            [disableInvalidFeedback]="true" class="was-validated">
            <!-- force  display of validation errors -->
            <label for="{{berthVisit.id}}-bollardFrom">Bollards</label>
            <div class="d-flex">
              <div class="input-group me-3">
                <span class="input-group-text" id="{{berthVisit.id}}-bollardFrom">from</span>
                <input [ngModel]="getTerminalVisitBollardFrom" disabled
                  [id]="berthVisit.id + '-bollardFrom'" appDecimalNumber class="form-control">
              </div>
              <div class="input-group">
                <span class="input-group-text" id="{{berthVisit.id}}-bollardTo">to</span>
                <input [ngModel]="getTerminalVisitBollardTo" disabled
                  [id]="berthVisit.id + '-bollardTo'" appDecimalNumber class="form-control">
              </div>
            </div>
          </app-form-group>
        } @else {
          @if (showBollardsForAgent()) {
            @if (validBollardsBasedOnBerths) {
              <app-status-alert type="info">
                Possible bollards are between {{ minPossibleBerthFrom }} and {{ maxPossibleBerthFrom }}
              </app-status-alert>
            }
            <app-form-group>
              <label for="{{berthVisit.id}}-bollardFrom">Bollards</label>
              <div class="d-flex">
                <div class="input-group me-3">
                  <span class="input-group-text" id="bollard-from">from</span>
                  <input [(ngModel)]="berthVisit.bollardFrom" (blur)="updateBollardsFrom($event)"
                    [required]="!!berthVisit.bollardTo && areBollardsUpdatable()"
                    [id]="berthVisit.id + '-bollardFrom'" appDecimalNumber
                    class="form-control {{bollardFromUnequalToTerminal ? 'has-diff' : ''}}">
                </div>
                <div class="input-group">
                  <span class="input-group-text" id="bollard-to">to</span>
                  <input [(ngModel)]="berthVisit.bollardTo" (blur)="updateBollardsTo($event)"
                    [required]="!!berthVisit.bollardFrom && areBollardsUpdatable()"
                    [id]="berthVisit.id + '-bollardTo'" appDecimalNumber
                    class="form-control  {{bollardToUnequalToTerminal ? 'has-diff' : ''}}">
                </div>
              </div>
            </app-form-group>
          }
        }
        @if (bothBollardsEntered() || !!suggestedBerth || !!berthVisit.berth || noBerthsFoundForTerminal) {
          <app-select-berth [berthVisit]="berthVisit" [isBerthOfTransfer]="isBerthOfTransfer"
            [firstBerth]="firstBerth"
            [disabled]="context.visit.terminalPlanningEnabled && !outsideRange && !noBerthsFoundForTerminal">
          </app-select-berth>
        }
        @if (noBerthsFoundForTerminal) {
          <div>
            <app-status-alert type="info">No berths found for this terminal are you sure the terminal is correct?
            </app-status-alert>
          </div>
        }
        @if (suggestedBerth) {
          <div>
            <app-status-alert type="info">Berth {{ suggestedBerth }} has been selected based on the chosen bollards.
            </app-status-alert>
          </div>
        }
        @if (outsideRange) {
          <div>
            <app-status-alert type="info">
              The center of the chosen bollards does not match with the chosen berth.
              Please select other bollards or another berth
            </app-status-alert>
          </div>
        }
        @if (planningBasedForcedWarning) {
          <div>
            <app-status-alert type="info" (close)="planningBasedForcedWarningOff()">'Planning based on' set to '1st
              Berth'
            </app-status-alert>
          </div>
        }
        @if (planningBasedMismatchWarning()) {
          <div>
            <app-status-alert type="info">'Planning based on' must be set to '1st Berth' for berths at container
              terminals that provide planning
            </app-status-alert>
          </div>
        }
        @if (linerServices.length > 0) {
          <app-form-group label="Liner service">
            <app-select [ngModel]="codeToLinerService(berthVisit.vesselServiceCode)"
              [options]="linerServices" required
              [formatter]="linerServiceNameFormatter"
              (ngModelChange)="setLinerService($event)"
              placeholder="Select a liner service" dataKey="code">
            </app-select>
          </app-form-group>
        }
        <div>
          <app-berth-visit-times [firstBerth]="firstBerth" [berthVisit]="berthVisit" [terminalVisit]="terminalVisit"
          [isBerthOfTransfer]="isBerthOfTransfer"></app-berth-visit-times>
        </div>
        <div>
          <app-planning-history
            [movementSpecifiers]="['Outgoing', 'departure']"
            [planningHistory]="getHarbourMasterInfo()?.planningHistory"
            [declaredDate]="getHarbourMasterInfo()?.etd"
            [originallyDeclaredDate]="getHarbourMasterInfo()?.basedOnTime">
          </app-planning-history>
        </div>
        <!--Dependency on vessel-->
        @if (context.visit.terminalPlanningApproved && context.visit.orderIncomingMovement && berthVisit.berth && firstBerth) {
          <app-exchange-at-berth [firstBerthVisit]="berthVisit"></app-exchange-at-berth>
        }
      </div>
      <div class="col-md">
        @if (!context.isMultiBerthTerminal(berthVisit)) {
          <app-terminal-planning-number-info
            [terminalVisit]="terminalVisit"
            [berthVisit]="berthVisit"
          [required]="berthVisit.terminalPlanningEnabled"></app-terminal-planning-number-info>
        }
        @if (berthVisit.terminalPlanningEnabled) {
          @if (context.isMultiBerthTerminal(berthVisit)) {
            <app-multi-berth [stevedore]="berthVisit.stevedore" [berthVisit]="berthVisit"></app-multi-berth>
          } @else {
            <app-form-group>
              <app-info class="formGroupLabel">
                <label>Operator remarks</label>
                <div class="tooltipContent">These remarks are shared between operator and terminal</div>
              </app-info>
              <textarea class="form-control" [(ngModel)]="berthVisit.operatorRemarks"
              [disabled]="!!berthVisit.ata || !!berthVisit.atd"></textarea>
            </app-form-group>
          }
        }
        @if (context.visit.terminalPlanningApproved) {
          <ng-container *ngTemplateOutlet="paDetails"></ng-container>
        }
        @if (terminalVisit?.info?.mooringOrientation && !context.visit.terminalPlanningApproved && berthVisit.terminalPlanningEnabled) {
          <app-form-group label="Mooring">
            <app-select [(ngModel)]="terminalVisit.info.mooringOrientation" [options]="terminalMoorings" disabled
            [formatter]="terminalMooringFormatter" id="{{berthVisit.id}}-terminalMooring"></app-select>
          </app-form-group>
        }
      </div>
      <app-visit-exemptions [berthVisit]="berthVisit"></app-visit-exemptions>
    </div>
    @if (berthVisit.terminalPlanningEnabled && terminalPlanningActive) {
      <div class="d-flex flex-row-reverse">
        @if (allowedToEditTerminalVisit) {
          <div class="d-lg-block ms-2 enabled">
            <app-register-terminal-planning [berthVisit]="berthVisit"></app-register-terminal-planning>
          </div>
        }
        <div class="d-lg-block ms-2">
          <app-terminal-planning-admin [berthVisit]="berthVisit"
          [terminalVisit]="terminalVisit"></app-terminal-planning-admin>
        </div>
        @if (canApprovePlanning) {
          <div class="d-lg-block ms-2">
            <button class="btn btn-secondary" type="button" (click)="approvePlanning(); $event.preventDefault();">
              Approve planning
            </button>
          </div>
        }
      </div>
    }
  } @else {
    <div class="row fieldset"
      [ngClass]="{'validate-for-next-declarant': isNextBerthVisit && context.isOrganisationNextDeclarant()}">
      <div class="col-md">
        <!-- Select berth -->
        <app-select-berth [berthVisit]="berthVisit" [isBerthOfTransfer]="isBerthOfTransfer" [firstBerth]="firstBerth"
          (change)="berthChanged()">
        </app-select-berth>
        @if (suggestedBerth) {
          <div>
            <app-status-alert type="info">Berth {{ suggestedBerth }} has been selected based on the chosen bollards.
            </app-status-alert>
          </div>
        }
        @if (outsideRange) {
          <div>
            <app-status-alert type="info">The center of the chosen bollards does not match with the chosen berth. Please
              select another berth.
            </app-status-alert>
          </div>
        }
        @if (planningBasedForcedWarning) {
          <div>
            <app-status-alert type="info" (close)="planningBasedForcedWarningOff()">'Planning based on' set to '1st
              Berth'
            </app-status-alert>
          </div>
        }
        @if (planningBasedMismatchWarning()) {
          <div>
            <app-status-alert type="info">'Planning based on' must be set to '1st Berth' for berths at container
              terminals that provide planning
            </app-status-alert>
          </div>
        }
        <!--Bollard from and to-->
        @if (context.visit.portOfCall.paDeclarationRequired) {
          <div class="fieldset"
            [ngClass]="{'disabled' :berthVisit.ata || berthVisit.atd}"
            >
            <app-form-group [disableInvalidFeedback]="true" class="was-validated"> <!-- force  display of validation errors -->
              <label for="{{berthVisit.id}}-bollardFrom">Bollards</label>
              <div class="d-flex">
                <div class="input-group me-3">
                  <span class="input-group-text" id="bollard-from">from</span>
                  <input [(ngModel)]="berthVisit.bollardFrom" (blur)="updateBollardsFrom($event)"
                    [required]="!!berthVisit.bollardTo && areBollardsUpdatable()"
                    [id]="berthVisit.id + '-bollardFrom'" appDecimalNumber class="form-control {{bollardFromUnequalToTerminal ? 'has-diff' : ''}}">
                </div>
                <div class="input-group">
                  <span class="input-group-text" id="bollard-to">to</span>
                  <input [(ngModel)]="berthVisit.bollardTo" (blur)="updateBollardsTo($event)"
                    [required]="!!berthVisit.bollardFrom && areBollardsUpdatable()"
                    [id]="berthVisit.id + '-bollardTo'" appDecimalNumber class="form-control  {{bollardToUnequalToTerminal ? 'has-diff' : ''}}">
                </div>
              </div>
              @if (showUseTerminalBollards()) {
                <div style="text-align: end;">
                  <input type="checkbox" id="{{berthVisit.id}}-useTerminalBollards" [(ngModel)]="useTerminalBollardsChecked"/>
                  &nbsp;Use terminal request ({{getTerminalVisitBollardFrom}} - {{getTerminalVisitBollardTo}})
                  <app-info>
                    <span class="tooltipContent">Use requested Terminal Bollards</span>
                  </app-info>
                </div>
              }
            </app-form-group>
          </div>
        }

        <div>
          <app-berth-visit-times [firstBerth]="firstBerth" [berthVisit]="berthVisit" [terminalVisit]="terminalVisit" [isBerthOfTransfer]="isBerthOfTransfer"></app-berth-visit-times>
        </div>

        <div>
          <app-planning-history
            [movementSpecifiers]="['Outgoing', 'departure']"
            [planningHistory]="getHarbourMasterInfo()?.planningHistory"
            [declaredDate]="getHarbourMasterInfo()?.etd"
            [originallyDeclaredDate]="getHarbourMasterInfo()?.basedOnTime">
          </app-planning-history>
        </div>
        <!--Dependency on vessel-->
        @if (context.visit.orderIncomingMovement && berthVisit.berth && firstBerth) {
          <app-exchange-at-berth [firstBerthVisit]="berthVisit"
          [entryDependency]="context.visit.visitDeclaration.portVisit.portEntry.entryDependency"></app-exchange-at-berth>
        }
      </div>
      <div class="col-md">
        <ng-container *ngTemplateOutlet="paDetails"></ng-container>
      </div>
      <app-visit-exemptions [berthVisit]="berthVisit"></app-visit-exemptions>
      <div class="d-lg-block ms-2">
        <app-terminal-status-admin [berthVisit]="berthVisit"
        [terminalVisit]="terminalVisit"></app-terminal-status-admin>
      </div>
    </div>
  }
}

<ng-template #paDetails>
  <div class="fieldset">
    <!--Mooring-->
    @if (context.visit.portOfCall.paDeclarationRequired) {
      <app-form-group>
        <label for="{{berthVisit.id}}-mooring" [ngClass]="{'required': requiredForOrder}">Mooring</label>
        <app-select [(ngModel)]="berthVisit.mooring" [required]="requiredForOrder" [options]="moorings"
          [formatter]="mooringFormatter" id="{{berthVisit.id}}-mooring"
          [disabled]="!!berthVisit.ata || !!berthVisit.atd"
          (ngModelChange)="firstBerth && context.visit.orderIncomingMovement && context.updateCalculatedEtas()"
          class="{{mooringUnequalToTerminal ? 'has-diff' : ''}}">
        </app-select>
        @if (showUseTerminalMooringCheckbox()) {
          <div style="text-align: end;">
            <input type="checkbox" id="{{berthVisit.id}}-useTerminalMooring" [(ngModel)]="useTerminalMooringCheckbox"/>
            &nbsp;Use terminal request
            <app-info>
              <span class="tooltipContent">Use requested Terminal Mooring</span>
            </app-info>
          </div>
        }
      </app-form-group>
    }
    <!--Purpose of visit-->
    <div [ngClass]="context.visitIsDeparted() && !context.isVisitReadonlyIgnoringDeparture() ? 'always-enabled' : ''">
      <app-form-group>
        <label for="{{berthVisit.id}}-visitPurposes" [ngClass]="{'required': requiredForOrder}">Visit purpose</label>
        <app-multiselect [(ngModel)]="berthVisit.visitPurposes" [options]="visitPurposes"
          [formatter]="visitPurposeFormatter" id="{{berthVisit.id}}-visitPurposes"
          [required]="requiredForOrder" placement="top-start" title="Select any number of visit purposes"
        [horizontal]="true"></app-multiselect>
      </app-form-group>
    </div>
    <!-- Agent transfer -->
    @if (showAgentTransfer()) {
      <app-agent-transfer></app-agent-transfer>
    }

    <!--Remarks-->
    @if (context.visit.portOfCall.paDeclarationRequired) {
      <app-form-group>
        <label for="{{berthVisit.id}}-remarks">Remarks</label>
        <textarea [(ngModel)]="berthVisit.remarks" rows="3" id="{{berthVisit.id}}-remarks" maxlength="152"
        class="form-control" [disabled]="!!berthVisit.ata || !!berthVisit.atd"></textarea>
      </app-form-group>
    }

    @if (showExemptions()) {
      <app-form-group label="Exemptions/forms">
        <app-multi-search [(ngModel)]="selectedExemptionTypes" (ngModelChange)="exemptionPopup($event)"
          [searchFunction]="availableExemptions" [inputFormatter]="exemptionFormatter"
          [minCharacters]="0" [disabled]="berthNotFilledIn || !!berthVisit.atd"
          placeholder="Select exemption">
        </app-multi-search>
      </app-form-group>
    }

    <app-shore-power [berth]="berthVisit.berth" [berthVisit]="berthVisit">
    </app-shore-power>
  </div>
</ng-template>
